module.exports = __webpack_public_path__ + "img/Back.f3f1ad05.svg";